export const assistantDocumentSx = {
  fontSize: '0.875rem',
  lineHeight: 1.65,
  overflowWrap: 'anywhere',
  '& h1': { fontSize: '1.25rem', lineHeight: 1.35 },
  '& h2': { fontSize: '1rem', lineHeight: 1.4 },
  '& h3, & h4, & h5, & h6': { fontSize: '0.875rem', lineHeight: 1.45 },
  '& h1, & h2, & h3, & h4, & h5, & h6': {
    color: 'text.primary', fontWeight: 600, letterSpacing: 0, mt: 2, mb: 0.75,
  },
  '& p, & ul, & ol': { mt: 0, mb: 1 },
  '& > :first-child': { mt: 0 },
  '& pre': { maxWidth: '100%', overflowX: 'auto' },
};
